interface FormFeedbackProps {
  status: "success" | "error";
  title: string;
  message: string;
}

const tone = {
  success: {
    wrapper: "border-secondary-200 bg-secondary-50 text-secondary-900",
    icon: "ri-checkbox-circle-fill",
    iconColor: "text-secondary-600",
  },
  error: {
    wrapper: "border-accent-300 bg-accent-50 text-foreground-900",
    icon: "ri-error-warning-fill",
    iconColor: "text-accent-700",
  },
} as const;

export default function FormFeedback({ status, title, message }: FormFeedbackProps) {
  const styles = tone[status];

  return (
    <div className={`flex items-start gap-3 rounded-lg border p-5 ${styles.wrapper}`} role="status">
      <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center ${styles.iconColor}`}>
        <i className={`${styles.icon} text-lg`} />
      </span>
      <div>
        <p className="font-heading text-sm font-bold">{title}</p>
        <p className="mt-1 text-sm leading-relaxed">{message}</p>
      </div>
    </div>
  );
}